import { h } from '../pragma.mjs';

export default () => {

    return (
        <div>

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikUdaje" href="#">Údaje</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Zeměměřictví</strong></li>
                </ul>
            </gov-breadcrumbs>
            
            <gov-tiles role="list">
                <gov-tile id="geoportal-link-tile" role="listitem" href="https://geoportal.cuzk.gov.cz/" target="_blank">
                    <p>Přístup k prostorovým datům resortu.</p>
                    <h3 slot="title">Geoportál&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="globe" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" id="rozcestnikZememerictviZmenaBodu" href="#">
                    <p>Chci oznámit změnu nebo závadu bodu bodového pole.</p>
                    <h3 slot="title">Změna bodu</h3>
                    <gov-icon type="complex" name="sms-notification" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" id="rozcestnikZememerictviPremisteniBodu" href="#">
                    <p>Chci podat žádost k přemístění nebo odstranění značky bodového pole.</p>
                    <h3 slot="title">Přemístění bodu</h3>
                    <gov-icon type="complex" name="remove-id" slot="icon"></gov-icon>
                </gov-tile>             
            </gov-tiles>
        </div>
    )

}